import React, { FunctionComponent } from 'react';
import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Price from '../../../../../../../../gqlCommon/components/presentation/Price';
import summaryStyles from '../../../../summary/summarySection/SummaryStyles';
import Translation from '../../../../../../../../gqlCommon/components/translation/Translation';
import usePlatformConfig from '../../../../../../../../common/react/usePlatformConfig';
import { selectedCurrencyVar } from '../../../../../../../../gqlCommon/graphql/cache';
import { usePersistedCurrencyPreference } from '../../../../../../../hooks/currency/usePersistedCurrencyPreference';
import { PriceDisplayType } from '../../../../../../../../../../common/enum/PriceDisplayType';
import { TaxTypes } from '../../../../../../../../../../common/enum/TaxTypes';
import { taxTypeTranslationMap } from '../../../../../../../constants/taxTypeTranslationMap';
import { GetCustomizeCar_customizeCar_prices_totalPrice_taxes } from '../../../../../../../graphql/queries/__generated__/GetCustomizeCar';
import { useReactiveVar } from '@apollo/client';

interface IFeesAndChargesRow {
  loading: boolean;
  tax?: GetCustomizeCar_customizeCar_prices_totalPrice_taxes;
}

const FeesAndChargesRow: FunctionComponent<IFeesAndChargesRow> = ({ loading, tax }) => {
  const styles = summaryStyles();
  const { isSecondaryCurrencyDisplay } = usePersistedCurrencyPreference();
  const {
    platformConfig: { priceDisplay },
  } = usePlatformConfig();
  const selectedCurrency = useReactiveVar(selectedCurrencyVar);

  if (!tax) {
    return null;
  }

  const { label, type, money } = tax;
  const hasTranslation = type in TaxTypes && !!taxTypeTranslationMap[type as TaxTypes];

  return (
    <Box key={type} className={styles.selectedOptionContainer} data-test={`customize:summary:expanded:tax:${type}`}>
      <Grid container={true} className={styles.selectedOptionTitlePrice}>
        <Typography variant="caption">
          {label ? label : hasTranslation ? <Translation id={taxTypeTranslationMap[type as TaxTypes]} /> : type}
        </Typography>
        <Price
          loading={loading}
          price={money.amount}
          currency={selectedCurrency}
          className={styles.optionPrice}
          priceDisplayType={isSecondaryCurrencyDisplay ? PriceDisplayType.SECONDARY : PriceDisplayType.PRIMARY}
          decimals={
            isSecondaryCurrencyDisplay
              ? priceDisplay.secondaryOptions.decimalScale
              : priceDisplay.primaryOptions.decimalScale
          }
        />
      </Grid>
    </Box>
  );
};

export default FeesAndChargesRow;
